
import { Routes } from '@angular/router';
import { FileComponent } from './file/file.component';
import { provideEffects } from '@ngrx/effects';
import { ContentEffects } from '../../domain/content/content.effects';
import { ContentService } from '../../domain/content/content.service';
import { provideState } from '@ngrx/store';
import { contentFeature } from '../../domain/content/content.state';
import { ExtraEffects } from '../../domain/extra/extra.effects';
import { extraFeature } from '../../domain/extra/extra.state';

export const FILE_ROUTES: Routes = [
	{
		path: '',
		providers: [provideEffects(ExtraEffects),provideState(extraFeature),provideEffects(ContentEffects), ContentService, provideState(contentFeature)],
		children: [
			{
				path: '',
				loadComponent: () =>
					import('../content-list/content-list/content-list.component').then(
						(m) => m.ContentListComponent
					)
			},
			{
				path: ':contentId',
				component: FileComponent,
				data: { title: 'dottnet.menu.file' }
			},
			{
				path: ':contentId/:titolo',
				component: FileComponent,
				data: { title: 'dottnet.menu.file' }
			}
		]
	}
];
